import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker, Input, Spin, TreeSelect, Pagination } from 'antd';
import moment from 'moment';

const tableList = (data, searchInfo, dispatch) => {
  return data.map((item, index) => {
    return (
      <li key={index}>
        <div className="tip-case reportTable">
          <div className="meeting-dept-user">
            {item.userId ? item.userName : <span className="dept-clk" onClick={()=>{
              let p = {searchInfo:{nodeCode: item.deptCode, startTime: searchInfo.startTime, endTime: searchInfo.endTime},
                nodeCode: item.deptCode, deptId: item.deptId, pageNo: 1, pageSize: 10};
              dispatch({
                type: 'meetingBillReport/searchByParam',
                payload: p
              });
              }
            }>{item.deptName}</span>}
          </div>
          <div className="meeting-room-price data-tr">{parseFloat(item.roomPrice).toFixed(2)}</div>
          <div className="meeting-svc-price data-tr">{parseFloat(item.svcPrice).toFixed(2)}</div>
          <div className="meeting-total-price data-tr">{parseFloat(item.roomPrice + item.svcPrice).toFixed(2)}</div>
        </div>
      </li>
    );
  });
};
export default ({ intl, dispatch, loading, meetingBillReport, account }) => {
  let deptMap = new Map();
  let convertDeptTree = childDepts => {
    for (let i = 0; i < childDepts.length; i++) {
      let temp = childDepts[i];
      temp.label = temp.name;
      temp.value = temp.id + ',' + temp.nodeCode;
      temp.key = temp.id + ',' + temp.nodeCode;
      temp.children = temp.depts;
      deptMap.set(temp.nodeCode, temp.id);
      if (temp.children.length > 0) {
        convertDeptTree(temp.children);
      }
    }
  };
  let treeData = account.allDeptTree || [];
  convertDeptTree(treeData);
  
  const {
    startTime,
    endTime,
    nodeCode,
    deptId,
    searchData,
    searchInfo,
    pageNo,
    pageSize,
  } = meetingBillReport;
  return (
    <div className="message-body report-container">
      <div className="report-bill">
        <Spin spinning={loading} size="large">
          <div className="messages-list">
            <div className="messages-title">
              <div className="report-div report-date">
                <label className="report-search-label">
                  <FormattedMessage id="meeting_bill_report_time" />
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (current && (current.startOf('day').valueOf() >= moment().startOf('day').valueOf() || (endTime && current.startOf('day').valueOf() >= endTime.startOf('day').valueOf())));
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'meetingBillReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={endTime}
                    disabledDate={current => {
                      return (current && ((startTime && startTime.valueOf() > current.valueOf()) || current.startOf('day').valueOf() >= moment().startOf('day').valueOf()));
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'meetingBillReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-area">
                <label className="report-search-label">
                  <FormattedMessage id="meeting_bill_report_dept" />
                </label>
                <div className="search-input">
                <span className="menu-border">
                  <i className="iconfont icon-sousuo" />
                  <TreeSelect
                    className="user-select-tree"
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                      minWidth: 200
                    }}
                    value={deptId ? deptId + "," + nodeCode : null}
                    allowClear
                    treeData={treeData}
                    placeholder={intl.formatMessage({ id: 'pls_check_depart' })}
                    treeDefaultExpandAll
                    notFoundContent={intl.formatMessage({
                      id: 'user_dept_notFound'
                    })}
                    onChange={e => {
                      if (e) {
                        dispatch({
                          type: 'meetingBillReport/setState',
                          payload: { nodeCode: e.split(',')[1], deptId: e.split(',')[0] }
                        });
                      } else {
                        dispatch({
                          type: 'meetingBillReport/setState',
                          payload: { nodeCode: '-1', deptId: '' }
                        });
                      }
                    }}
                  />
                </span>
                </div>
              </div>
              <div className="report-div report-btn-groups">
                <button className="button button_primary"
                  onClick={() => {
                    let searchInfo = {nodeCode, startTime, endTime};
                    dispatch({
                      type: 'meetingBillReport/searchByParam',
                      payload: {searchInfo: searchInfo}
                    });
                  }}
                >
                  <FormattedMessage id="meeting_bill_report_search" />
                </button>
                <button className="button button_ghost"
                  onClick={() => {
                    let p = {searchInfo:{nodeCode: '-1', startTime: null, endTime: null},
                      nodeCode: '-1', deptId: '', startTime: null, endTime: null, pageNo: 1, pageSize: 10};
                    dispatch({
                      type: 'meetingBillReport/searchByParam',
                      payload: p
                    });
                  }}
                >
                  <FormattedMessage id="meeting_bill_report_reset" />
                </button>
              </div>
            </div>
            <div className="button-row">
              {searchInfo.nodeCode && searchInfo.nodeCode.length > 3 && <button className="button button_ghost button_blue"
                onClick={() => {
                  let p = {searchInfo:{startTime: null, endTime: null}, startTime: null, endTime: null, pageNo: 1, pageSize: 10};
                  if(nodeCode && nodeCode.length > 3) {
                    p.nodeCode = nodeCode.substr(0, nodeCode.length-3);
                    p.deptId = deptMap.get(p.nodeCode);
                  } else {
                    p.nodeCode = '-1';
                    p.deptId = '';
                  }
                  p.searchInfo.nodeCode = p.nodeCode;
                  dispatch({
                    type: 'meetingBillReport/searchByParam',
                    payload: p
                  });
                }}
              >
                <FormattedMessage id="meeting_bill_report_return" />
              </button>}
              <button className="button button_ghost"
                onClick={() => {
                  dispatch({ type: 'meetingBillReport/downloadBill' });
                }}
              >
                <FormattedMessage id="meeting_bill_report_export" />
              </button>
            </div>
          </div>

          <div
            className="messages-list billReport bill-report-table"
            style={{ "minHeight": "650px" }}
          >
            <div className="tip-case reportTable">
              <div className="meeting-dept-user">
                <FormattedMessage id="meeting_bill_report_dept_user" />
              </div>
              <div className="meeting-room-price">
                <FormattedMessage id="meeting_bill_report_room_price" />
              </div>
              <div className="meeting-svc-price">
                <FormattedMessage id="meeting_bill_report_svc_price" />
              </div>
              <div className="meeting-total-price">
                <FormattedMessage id="meeting_bill_report_total_price" />
              </div>
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                  ? 'emptyData'
                  : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list &&
              tableList(searchData.list, searchInfo, dispatch)}
            </ul>
            <div className="page-cont">
              {searchData.total && searchData.total > 0 ? (
                <Pagination
                  total={searchData.total || 0}
                  showQuickJumper
                  showSizeChanger
                  pageSize={pageSize || 10}
                  current={pageNo || 1}
                  onShowSizeChange={(page, pageSize) => {
                    let p = { startTime: searchInfo.startTime, endTime: searchInfo.endTime, nodeCode:searchInfo.nodeCode,
                      deptId:deptMap.get(searchInfo.nodeCode), pageNo: page, pageSize: pageSize};
                    dispatch({
                      type: 'meetingBillReport/searchByParam',
                      payload: p
                    });
                  }}
                  onChange={(page, pageSize) => {
                    let p = { startTime: searchInfo.startTime, endTime: searchInfo.endTime, nodeCode:searchInfo.nodeCode,
                      deptId:deptMap.get(searchInfo.nodeCode), pageNo: page, pageSize: pageSize};
                    dispatch({
                      type: 'meetingBillReport/searchByParam',
                      payload: p
                    });
                  }}
                />
              ) : null}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/MeetingBillReportDetail.js